module.exports = "<div class=\"card tabs-navigation\"><div class=card-body><ul class=\"list-unstyled d-flex flex-wrap tabs-list\"><li class=tab ng-repeat=\"tab in $ctrl.tabs\"><a class=tab-link ui-sref={{::tab.sref}} ui-sref-active=active>{{::tab.title}}</a></li></ul></div></div>";


//////////////////
// WEBPACK FOOTER
// ./app/shared/components/gmc-tabs/components/nav-tabs/nav-tabs.component.html
// module id = 545
// module chunks = 31